"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PoliticasDeGarantia = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NormasDeAlojamiento = ({
  value,
  name,
  label,
  handleChangeNormas,
  styles
}) => {
  return (0, _react2.jsx)(_material.Grid, {
    container: true,
    alignItems: "center"
  }, (0, _react2.jsx)(_material.Grid, {
    item: true,
    css: styles.itemNormas
  }, (0, _react2.jsx)(_material.TextField, {
    select: true,
    variant: "standard",
    id: "demo-simple-select",
    value: value,
    name: name,
    onChange: e => handleChangeNormas(e),
    css: styles.selectNormas
  }, (0, _react2.jsx)(_material.MenuItem, {
    value: null
  }, "No especificar"), (0, _react2.jsx)(_material.MenuItem, {
    value: 1
  }, "Si"), (0, _react2.jsx)(_material.MenuItem, {
    value: 0
  }, "No"))), (0, _react2.jsx)(_material.Grid, {
    css: styles.itemNormasLabel
  }, (0, _react2.jsx)(_material.Typography, {
    css: styles.normas
  }, label)));
};

class PoliticasDeGarantia extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChangeSolicitaGarantia = this.handleChangeSolicitaGarantia.bind(this);
    this.handleChangeOptionsGarantia = this.handleChangeOptionsGarantia.bind(this);
    this.handleChangeNormas = this.handleChangeNormas.bind(this);
  }

  handleChangeSolicitaGarantia(event) {
    this.props.onChange(event.target.value, 'garantia');
  }

  handleChangeNormas(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  handleChangeOptionsGarantia(event) {
    this.props.onChange(event.target.checked ? 1 : 0, event.target.name);
  }

  render() {
    const {
      garantia,
      aceptaFamilias,
      aceptaParejas,
      aceptaGrupoJovenes,
      aptoNiños,
      aptoBebes,
      aceptaMascotas,
      aptoMovilidadReducida,
      permiteFumar,
      permiteHacerFiestas,
      permiteRecibirVisitas,
      permiteMusica,
      aReintegrar,
      datosTarjeta,
      fotoDni,
      presentarDocumento,
      firmaContrato,
      valorAReintegrar
    } = this.props;
    return (0, _react2.jsx)(_material.Box, {
      mb: 2,
      mt: 2
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "Pol\xEDticas de garant\xEDas"), (0, _react2.jsx)(_material.Box, {
      mt: 2,
      mb: 2
    }, (0, _react2.jsx)(_material.FormControl, {
      component: "fieldset"
    }, (0, _react2.jsx)(_material.RadioGroup, {
      "aria-label": "gender",
      name: "gender1",
      value: garantia,
      onChange: this.handleChangeSolicitaGarantia
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.politicas,
      name: "garantia",
      value: "0",
      control: (0, _react2.jsx)(_material.Radio, {
        color: "primary"
      }),
      label: "No se solicita garantia"
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.politicas,
      name: "garantia",
      value: "1",
      control: (0, _react2.jsx)(_material.Radio, {
        color: "primary"
      }),
      label: "Si se solicita garantia"
    }))), garantia == 1 ? (0, _react2.jsx)(_material.Grid, {
      container: true,
      direction: "column",
      css: _style.default.gridGarantias
    }, (0, _react2.jsx)(_material.Grid, {
      container: true,
      item: true,
      alignItems: "flex-start",
      css: _style.default.widthAReintegrar
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!aReintegrar,
        onChange: this.handleChangeOptionsGarantia,
        name: "a_reintegrar",
        color: "primary"
      }),
      label: "Efectivo $ARS"
    }), (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      name: "valor_a_reintegrar",
      error: valorAReintegrar < 1000,
      disabled: !aReintegrar,
      onBlur: this.handleChangeNormas,
      defaultValue: valorAReintegrar,
      type: "number",
      inputProps: {
        step: 500,
        min: 1000,
        max: 100000
      },
      helperText: valorAReintegrar < 1000 ? 'el monto a reintegrar no puede ser menor a $1000' : '(será reintegrado al huésped al retirarse)'
    })), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.widthGrantias,
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!datosTarjeta,
        onChange: this.handleChangeOptionsGarantia,
        name: "datos_tarjeta",
        color: "primary"
      }),
      label: "N\xFAmeros de tarjeta de cr\xE9dito Visa o Mastercard"
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.widthGrantias,
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!fotoDni,
        onChange: this.handleChangeOptionsGarantia,
        name: "foto_dni",
        color: "primary"
      }),
      label: "Env\xEDo de foto de DNI previo al ingreso"
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.widthGrantias,
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!presentarDocumento,
        onChange: this.handleChangeOptionsGarantia,
        name: "presentar_documento",
        color: "primary"
      }),
      label: "Presentar pl\xE1sticos de DNI o Pasaporte"
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.widthGrantias,
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!firmaContrato,
        onChange: this.handleChangeOptionsGarantia,
        name: "firma_contrato",
        color: "primary"
      }),
      label: "Firma de contrato de locaci\xF3n temporal"
    })) : null), (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "Normas del alojamiento"), (0, _react2.jsx)(_material.Box, {
      mt: 2
    }, (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aceptaFamilias != null ? aceptaFamilias : '',
      name: "acepta_familias",
      label: "Acepto familias",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aceptaParejas != null ? aceptaParejas : '',
      name: "acepta_parejas",
      label: "Acepto parejas",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aceptaGrupoJovenes != null ? aceptaGrupoJovenes : '',
      name: "acepta_grupo_jovenes",
      label: "Acepto grupo de J\xF3venes",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aptoNiños != null ? aptoNiños : '',
      name: "apto_ni\xF1os",
      label: "es apto para Ni\xF1os (2 a 12 a\xF1os)",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aptoBebes != null ? aptoBebes : '',
      name: "apto_bebes",
      label: "es apto para Beb\xE9s (0 a 2 a\xF1os)",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aceptaMascotas != null ? aceptaMascotas : '',
      name: "acepta_mascotas",
      label: "acepto Mascotas",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: aptoMovilidadReducida != null ? aptoMovilidadReducida : '',
      name: "apto_movilidad_reducida",
      label: "es apto para personas con movilidad reducida",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: permiteFumar != null ? permiteFumar : '',
      name: "permite_fumar",
      label: "se permite fumar en el interior",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: permiteHacerFiestas != null ? permiteHacerFiestas : '',
      name: "permite_hacer_fiestas",
      label: "se permite hacer fiestas",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: permiteRecibirVisitas != null ? permiteRecibirVisitas : '',
      name: "permite_recibir_visitas",
      label: "se permite recibir visitas",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    }), (0, _react2.jsx)(NormasDeAlojamiento, {
      value: permiteMusica != null ? permiteMusica : '',
      name: "permite_musica",
      label: "se permite colocar musica alta",
      handleChangeNormas: this.handleChangeNormas,
      styles: _style.default
    })));
  }

}

exports.PoliticasDeGarantia = PoliticasDeGarantia;
var _default = PoliticasDeGarantia;
exports.default = _default;